import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LineShareButton,
} from "react-share";
import { Box } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import ChatIcon from "@material-ui/icons/Chat";

const SocialSharing = ({ title = "", url = "" }) => {
  const shareDesc = "ピッタプットで申し込み受付中！";
  const hashtags = ["ピッタプット"];

  return (
    <Box style={{ display: "inline-block" }}>
      {/* Facebook */}
      <FacebookShareButton url={url} quote={shareDesc} hashtag={`#${hashtags[0]}`}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "8px 12px",
            backgroundColor: "#1877F2",
            color: "#fff",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "8px",
          }}
        >
          <FacebookIcon style={{ marginRight: "4px" }} />
          シェア
        </div>
      </FacebookShareButton>

      {/* Twitter */}
      <TwitterShareButton url={url} title={`${shareDesc} ${title}`} hashtags={hashtags}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "8px 12px",
            backgroundColor: "#1DA1F2",
            color: "#fff",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "8px",
          }}
        >
          <TwitterIcon style={{ marginRight: "4px" }} />
          ツイート
        </div>
      </TwitterShareButton>

      {/* LINE */}
      <LineShareButton url={url} title={title}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "8px 12px",
            backgroundColor: "#00c300",
            color: "#fff",
            borderRadius: "4px",
            cursor: "pointer",
            marginRight: "8px",
          }}
        >
          <ChatIcon style={{ marginRight: "4px" }} />
          LINEで送る
        </div>
      </LineShareButton>
    </Box>
  );
};

export default SocialSharing;
